import React from "react"
import PropTypes from "prop-types"

function Twitter({ color, width, height, ...props }) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        className="fill-current"
        fill={color}
        fillRule="evenodd"
        d="M24 4.72676C23.1 5.12676 22.2 5.42676 21.2 5.52676C22.2 4.92676 23 3.92676 23.4 2.82676C22.4 3.42676 21.4 3.82676 20.3 4.02676C19.4 3.02676 18.1 2.42676 16.7 2.42676C14 2.42676 11.8 4.62676 11.8 7.32676C11.8 7.72676 11.8 8.12676 11.9 8.42676C7.7 8.22676 4.1 6.22676 1.7 3.22676C1.2 4.02676 1 4.82676 1 5.72676C1 7.42676 1.9 8.92676 3.2 9.82676C2.4 9.82676 1.6 9.62676 1 9.22676C1 9.22676 1 9.22676 1 9.32676C1 11.7268 2.7 13.7268 4.9 14.1268C4.5 14.2268 4.1 14.3268 3.6 14.3268C3.3 14.3268 3 14.3268 2.7 14.2268C3.3 16.2268 5.1 17.6268 7.3 17.6268C5.6 18.9268 3.5 19.7268 1.2 19.7268C0.8 19.7268 0.4 19.7268 0 19.6268C2.2 21.0268 4.8 21.8268 7.5 21.8268C16.6 21.8268 21.5 14.3268 21.5 7.82676C21.5 7.62676 21.5 7.42676 21.5 7.22676C22.5 6.52676 23.3 5.62676 24 4.72676Z" 
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

Twitter.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

Twitter.defaultProps = {
  color: "#767171",
  width: 24,
  height: 24,
}

export default Twitter;
